import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';

const absToolResourcesUrl = 'users/abs_tool_resources/';

export default function prefetchResourceUsers(client: APIClient) {
  prefetchQuery(absToolResourcesUrl, client, {});
}
